// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import colors from '@tcp/core/styles/themes/TCP/colors';

const styles = css`
  .login-checkout-section-container {
    margin: 0px auto !important;
    max-width: 600px;
    width: auto;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0px auto !important;
    }
  }
  background: ${colors.WHITE};
  ${(props) =>
    props && props.isNewLoginScreen
      ? `
    margin-top: 28px;
    @media ${props.theme.mediaQuery.smallMax} {
      margin-top: 0;
    }
  `
      : ``}
  .rounded-corner {
    border-radius: 6px;
  }
  .underline {
    border-bottom: 2px solid ${(props) => props.theme.colorPalette.blue[200]};
    width: 150px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.REG} auto
      ${(props) => props.theme.spacing.ELEM_SPACING.LRG} auto;
  }
`;

export default styles;
